import React from 'react'

const Footer: React.FC = () => {
  return (
    // <footer className="app-footer">
    //   <div>© {new Date().getFullYear()} MyAssets</div>
    //   <div>Built with React + Vite</div>
    // </footer>
    <></>
  )
}

export default Footer
